import React from "react";
import {connect} from "react-redux";

import {getTermByID} from "state/teachers/selectors";

import Card from "components/Card";
import Date from "components/Date";

// "name", "startDate", "endDate", "breakStartDate", "breakEndDate"
class Term extends React.Component {
  render() {

    const { name, startDate, breakStartDate, breakEndDate, endDate } = this.props.term.toJS();

    return (
      <Card>
        <Card.Body>
          <div className="term">
            <div className="term__name">{name}</div>
            <table className="term__dates">
              <tbody>
                <tr>
                  <td className="term__date-label">Term Starts</td>
                  <td className="term__date-value"><Date date={startDate} /></td>
                </tr>
                <tr>
                  <td className="term__date-label">Half Term Starts</td>
                  <td className="term__date-value"><Date date={breakStartDate} /></td>
                </tr>
                <tr>
                  <td className="term__date-label">Half Term Ends</td>
                  <td className="term__date-value"><Date date={breakEndDate} /></td>
                </tr>
                <tr>
                  <td className="term__date-label">Term Ends</td>
                  <td className="term__date-value"><Date date={endDate} /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    );

  }
}


export default connect(
  (state, { termID }) => ({
    term: getTermByID(state, termID)
  })
)(Term);



// WEBPACK FOOTER //
// ./src/components/teachers/term_calendar/Term.js